import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

/**
 * Props:
 * - title: string (section heading)
 * - items: Array<{ title: string, content: string }>
 * - defaultOpenIndex: number | null
 */
const FAQHome = ({ items = [], defaultOpenIndex = 0 }) => {
  const [openIndex, setOpenIndex] = useState(
    typeof defaultOpenIndex === "number" ? defaultOpenIndex : null,
  );

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="bg-white mt-2">
      <div className="w-full max-w-6xl mx-auto">
        {/* FAQ List */}
        <div className="space-y-4">
          {items.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className={`
                  rounded-[10px]
                  border-0
                  overflow-hidden
                  transition-all duration-300
                  ${
                    isOpen
                      ? "backdrop-blur-[15px] shadow-[0_4px_4px_0_#D1DFEA6B,-3px_-3px_10px_0_#D1DFEA_inset]"
                      : "backdrop-blur-[30px] shadow-[-20px_-20px_30px_0_#D1DFEA4D,-15px_-15px_20px_0_#D1DFEA66_inset]"
                  }
                `}
              >
                {/* Question */}
                <button
                  onClick={() => toggle(index)}
                  className="
                  w-full flex items-center justify-between px-6 py-5 text-left
                  
                  
                  "
                >
                  <span
                    className="
                      font-roboto font-medium text-[#10324F]
                      text-[16px] leading-[170%]
                      tracking-[0.04em] capitalize
                    "
                  >
                    {item.title}
                  </span>

                  <FaChevronDown
                    className={`text-[#10324F]/70 text-sm transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {/* Divider */}
                <div className="h-px w-full bg-[#d9e7f3]" />

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    isOpen ? "max-h-auto opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div
                    className="
                      px-6 py-4
                      font-roboto font-normal
                      text-[#10324F]
                      text-sm
                      leading-[170%]
                      tracking-[0.04em]
                      capitalize
                    "
                  >
                    <span dangerouslySetInnerHTML={{ __html: item.content }} />
                  </div>
                </div>
              </div>
            );
          })}

          {items.length === 0 && (
            <div className="text-center text-[#10324F] font-roboto text-sm py-10">
              No FAQs available.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQHome;
